<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_v"></a><strong>Contents</strong></h2>
<p class="toc1"><a class="nounder" href="#/xhtml/forword#forword">Foreword</a> by John Maxwell</p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">The Opportunity</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">The Meeting</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">The Secret</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">A Different Approach</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Where Are You Going?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">What’s Most Important?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">An Engaging Conversation</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">An Insight with Impact</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">How Can It Be Better?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">What Is Success?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">How’s Your Credibility?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Serving Leaders</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Let’s Review</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">Passing the Baton</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample"><strong>Resources</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch15#ch15a" title="Link target outside of Sample">Debbie’s Secret Notes</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Self-Assessment: Are You a Serving Leader?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">Frequently Asked Questions</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/app01#app01" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/app02#app02" title="Link target outside of Sample">Services Available</span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?61dc5602